import BaseService from "@/shared/base.service";
import { PaymentResponse } from "@/types/response/payment";
import { PaymentParams } from "@/types/request/getPayment";


export class PaymentService {
  static async GetPayments(payload: PaymentParams): Promise<PaymentResponse | null> {
    try {
      const params = { ...payload };

      const queryParams = Object.fromEntries(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        Object.entries(params).filter(([_, v]) => v != null)
      );

      const response = await BaseService.get<PaymentResponse>(
        `payments`,
        queryParams
      );

      return response ?? null;
    } catch (error) {
      console.error("Error in GetPayments:", error);
      return null;
    }
  }
}
